import { v4 as uuidv4 } from 'uuid'
import JobTypes from '../helpers/JobTypesEnum'
import { STORAGE_PATH } from '../config'

const podeserdesligado = {
  id: uuidv4(),
  name: 'Podeserdesligado',
  path: '/podeserdesligado',
  bios: [
    'Projeto de Jhonatta Vicente iniciado a partir da percepção do acesso rarefeito de pessoas pretas aos equipamentos para se produzir música no Brasil. Como provocação, denuncia narrativas apropriadoras que insistem em excluir pessoas negras do protagonismo de suas próprias histórias. Seu trabalho se desdobra em vários formatos: produção de beats, música eletrônica experimental e trilha sonora para filmes.',
    'A project by Jhonatta Vicente that started from the perception of the rarefied access of black people to the equipment of music production in Brazil. As a provocation, it denounces appropriating narratives which insist on excluding black people from the protagonism of their own stories. His work unfolds in several formats: beats production, experimental electronic music and film soundtrack.',
  ],
  jobs: [
    {
      id: uuidv4(),
      title: 'Quando bate a calmaria',
      type: JobTypes.VIDEO,
      path: '/quando-bate-a-calmaria',
      image: '/assets/podeserdesligado/quando-bate-a-calmaria.png',
      imageHover: '/assets/podeserdesligado/quando-bate-a-calmaria_hover.png',
      texts: [
        'A calma desmente muitas cafonices. Mesmo desdobrando-se em BPMs elevados, a brisa é valiosa e às vezes bate. É possível respirar, umedecer, lubrificar. É preciso dizer que também é sobre errar. "Calmaria" surge como uma série no IGTV de @podeserdesligado a partir de improvisos para escoar os reflexos de uma convivência confinada e sequenciada.',
        `Calmness belies many corny things. Even unfolding itself via high BPMs, the breeze is valuable and sometimes it hits. It becomes possible to breathe, moisten, lubricate. It must be said that it is also about making mistakes. "Calmaria" first appears as a series on @podeserdesligado's IGTV, made through improvisations to reflect upon a confined and sequenced coexistence.`,
      ],
      pages: [
        {
          id: uuidv4(),
          link: 'Mix',
          type: JobTypes.AUDIO,
          title: 'Quando Bate a Calmaria Vol. I',
          src: `${STORAGE_PATH}/Podeserdesligado/Podeserdesligado+-+Quando+Bate+a+Calmaria+Vol+1.wav`,
          path: '/mix',
        },
        {
          id: uuidv4(),
          link: 'Video 1',
          title: 'A33',
          src: `${STORAGE_PATH}/Podeserdesligado/Podeserdesligado+-+A33.mp4`,
          // sizes: [720 , 1280],
          sizes: [2.85, 5],
          path: '/a33',
        },
        {
          id: uuidv4(),
          link: 'Video 2',
          title: 'A34',
          src: `${STORAGE_PATH}/Podeserdesligado/Podeserdesligado+-+A34.mp4`,
          sizes: [2.85, 5],
          path: '/a34',
        },
        {
          id: uuidv4(),
          link: 'Video 3',
          title: 'A35',
          src: `${STORAGE_PATH}/Podeserdesligado/Podeserdesligado+-+A35.mp4`,
          sizes: [2.85, 5],
          path: '/a35',
        },
      ]
    },
  ],
}

export default podeserdesligado
